export function Classic({
    inputData,
}) {
    return (
        <div className="invitation" id="invitation-print-area">
            <div className={`invite-card-${inputData.theme}`}>
                <h1>{inputData.title}</h1>
                <p className={`invite-subtitle-${inputData.theme}`}>{inputData.subtitle}</p>
                <div className={`invite-details-${inputData.theme}`}>
                    <p><span>Event:</span> {inputData.event}</p>
                    <p><span>Date:</span> {new Date(inputData.date).toDateString()}</p>
                    <p><span>Time:</span> {inputData.time}</p>
                    <p><span>Venue:</span> {inputData.venue}</p>
                </div>
                <footer>
                    {inputData.footer}
                </footer>
            </div>
        </div>
    );
}